/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".travel-buddy-modal .action-row{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;gap:12px}.travel-buddy-modal ig-field input{width:calc(100% - 41px)}.travel-buddy-modal ig-drop-down{z-index:auto}.travel-buddy-modal ig-drop-down .drop-down-container{z-index:9}.travel-buddy-modal ig-drop-down .drop-down-container div[items]{max-height:500px;overflow-y:auto}.travel-buddy-modal ig-accordion .text-left{max-height:300px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/travel.buddy.conversations/travel.buddy.conversations.modal.component.scss.ngstyle.js.pre-build-optimizer.js